import { Routes, Route } from "react-router-dom"
import { useState } from "react"
import "./App.css"
import Nav from "./components/Nav"
import Timeline from "./components/Timeline"
import Modal from "./components/Modal"
import ProjectsDark from "./components/ProjectsDark"


function App() {
  const [open, setOpen] = useState(false)
  return (
    <div className="App font-sometype">
      <Nav open={open} setOpen={setOpen}/>
      <Modal 
        open={open}
        setOpen={setOpen}
        image={"assets/saraWasimResume1.png"}
        image2={"assets/saraWasimResume2.png"}
        image3={"assets/saraWasimResume3.png"}

      />
      <Routes>
        <Route path="/" element={<ProjectsDark />} />
        {/* <Route path="/about" element={<About />} /> */}
        <Route path="/timeline" element={<Timeline />} />
      </Routes>
    </div>
  )
}

export default App
